import ShareLotDialog from './ShareLotDialog';

export default ShareLotDialog;



// WEBPACK FOOTER //
// ./src/components/ShareLotDialog/index.js